import { CHAT } from '../../../services/socket.js';
import { Toast } from 'mint-ui';
import { dataHandle } from '../../../services/data-handle.js';
import { emoji } from '../emoji/emoji.js'
import bus from '../../eventBus';
import '../../../services/recorder/recorder-core';
//import '../../../services/recorder/wav';  // 加载wav编码器
import '../../../services/recorder/mp3';  // 加载mp3编码器
import '../../../services/recorder/mp3-engine';  // 加载mp3编码器
const maxLength = 800;
export default {
    props: {
        smartList: Array,
        toolShow: Boolean,
        clientId: String,
        clientType: [String, Number],
        businessType: [String, Number],
    },
    data() {
        return {
            emoji,
            businessId: '',
            inputText: '',
            accessKey: '',
            inputHeight: 0,
            smartHtmlList: [],
            smartTextList: [],
            voiceBtnShow: true,
            touch: {
                startX: 0,
                startY: 0,
                moveDistanceX: 0,
                moveDistanceY: 0
            },
            record: {  // 录音相关
                press: false,
                rate: 0,
                duration: 0,
                isSwipeTop: false,
                cancel: false,
                recorder: null,
                setting: {
                    type: 'mp3',
                    sampleBits: 16,         // 采样位数，支持 8 或 16，默认是16
                    sampleRate: 48000,      // 采样率，支持 11025、16000、22050、24000、44100、48000
                },
                mcounter: 0,
                recording: false,
                file: '',
                recordId: '',   // 微信录音本地文件Id
                intervaltimerid: null,  // 微信录音计时
                maxTime: 60,   // 录音最长
                countdown: 10,
                intervaltimerRate: null
            },
            isClick: true,  // 长按语音时会出发click事件
            clickTimeout: null,
            emojiFlag: false,
            sending: false,
            isIos: false,
            emojiObj: null,
            emojiCodeExp: null,
            menuList: [],
            enterkey: false,
            locking: false,
            docLabels: [],
            docLabelVisible: false,
            slsLabelList: [],
            atIndex: 0,
            LabelLeft: 40,
            range: null,
            sel: null
        }
    },
    mounted() {
        this.toEmojiObj();
        // 判断设备是否未ISO
        this.isIos = this.isIosOrAndroid() == 2 ? true : false;
        sessionStorage.setItem('inputMinHeight',this.$refs['inputContent'].clientHeight);
        this.businessId = sessionStorage.getItem('business');
        this.accessKey = sessionStorage.getItem('accessKey');
        if (sessionStorage.getItem('menuList')) {
            this.menuList = JSON.parse(sessionStorage.getItem('menuList'));
        }
        if (sessionStorage.getItem('docLabels')) {
            this.docLabels = JSON.parse(sessionStorage.getItem('docLabels'));
            if (this.docLabels.length == 1) {
                this.slsLabelList = [...this.docLabels];
            }
        }
        bus.$on('send',(data)=>{ // 监听其他组件的信息
            // console.log(data);
            this.sendMsg(data.type, data.content);
        });
        if(this.isIosWechat()) {
            this.getTicket();
        }
    },
    beforeDestroy () {
        bus.$off("send"); // 解绑，否则会重复事件
        // 销毁录音实例，置为null释放资源，fn为回调函数，
        if(this.record.recorder) {
            if(Recorder.IsOpen()) {
                this.record.recorder.close(()=>{
                });
            }
            this.record.recorder = null;
        }
    },
    watch: {
        'docLabelVisible'(value) {
          if (value) {
                document.body.addEventListener('click', this.closeDocLableWrap)
          } else {
                document.body.removeEventListener('click', this.closeDocLableWrap)
          }
        }
    },
    computed: {
        inputStyle() {
            if(this.inputHeight) {
                return {
                    height: `${this.inputHeight}px`
                }
            }else {
                return {}
            }
        }
    },
    methods: {
        /**
         * 转换emoji对象
         * */
        toEmojiObj(){
            this.emojiCodeExp =  new RegExp('(' + Object.keys(emoji).map(key=>key).join('|') + ')', 'g');
        },
        /**
         * 判断设备类型
         * */
        isIosOrAndroid(){
            let support = Recorder.Support();
            var u = navigator.userAgent.toLowerCase();
            // 文档问答业务不展示录音
            if (this.businessType == 2) {
                return 2;
            }
            // recorder插件不支持的设备(UC浏览器)
            if (!support || u.indexOf('ucbrowser') > -1) {
                return 2;
            }
            var isAndroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1; //android终端
            if (isAndroid) {
                // 低于android7.0版本不支持
                var match = u.match(/android (.*?);/);
                var version = match ? match[1].split(".")[0] : -1;
                if (version < 7) {
                    return 2;
                }
                return 1
            }
            var isiOS = !!u.match(/\(i[^;]+;( U;)? cpu.+mac os x/); //ios终端
            if (isiOS) {
                return 2
            }
            return 0
        },
        /**
         * 输入内容时
         * @param { Object }
         */
        contentInput(e) {
            this.closeDocLableWrap();
            let html = document.getElementById('wlb_inputArea').innerHTML.trim();
            let content = this.htmlToStr(html);
            if (content != '') {
                this.enterkey = true;
                if (this.businessType == 2) {
                    // 判断最后输入的字符是否为@，是并且为文本文旦机器人，则弹出文档标签选择窗
                    let lastStr = content.substr(-1);
                    if (lastStr === '@') {
                        this.sel = this.getSelection();
                        this.range = this.getSelection().getRangeAt(0);
                        this.showDocLabelWrap(e);
                    }
                }
            }else{
                this.enterkey = false;
            }
            this.$parent.getConversationH();
            this.$parent.scrollBottom();
            this.getSmartArr(content);
            CHAT.socket.emit('typing', {content: content, clientId: this.clientId, accessKey: this.accessKey});
        },
        /**
         * 按下键盘键
         * */
        keydown(e){
            const {ctrlKey, keyCode} = e;
            if (keyCode === 13) {
                e.preventDefault();
                let html = document.getElementById('wlb_inputArea').innerHTML.trim();
                this.inputText = this.htmlToStr(html);
                this.send(e);
            }
        },
        /**
         * 当键盘弹起时触发
         * */
        keyup(e){
        },
        /**
         * 复制
         * */
        pasteContent(e){
            var that = this;
            const dom = document.querySelector('#wlb_inputArea');
            const clipdata = e.clipboardData && e.clipboardData.items;
            const len = dom.innerHTML.length;
            if (clipdata && clipdata.length > 0) {
                const text = e.clipboardData.getData('text/plain')
                const data = Array.from(clipdata).filter(item => {
                    return ~item.type.indexOf('image/')
                })[0];
                if (data && !text) {
                    e.preventDefault();
                } else {
                    const html = e.clipboardData.getData('text/html');
                    //文本复制
                    if (!/chat-emoji-icon/g.test(html)) {
                        e.preventDefault();
                        document.execCommand("insertText", false, text);
                    }
                    dom.scrollTop = dom.scrollHeight;
                }
            }
        },
        /**
         * 移动光标到最后位置
         * */
        moveCaret() {
            try {
                const dom = document.querySelector('#wlb_inputArea');
                dom.focus();
                const range = document.createRange();
                range.selectNodeContents(dom);
                range.collapse(false);
                const selection = this.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            } catch (e) {

            }
        },
        /**
         * 获取焦点并插入html
         * */
        insertHtmlAtCaret(html,clear){
            const dom = document.querySelector('#wlb_inputArea');
            if (clear) {
                dom.innerHTML = '';
            }
            const len = dom.innerHTML.length;
            dom.focus();
            if (this.range && len > 0) {
                this.sel.removeAllRanges();
                this.sel.addRange(this.range);
            }
            document.execCommand("insertHTML", false, html);
            this.$nextTick(()=>{
                if (len == 0) {
                    this.moveCaret();
                }
                this.contentInput();
            });
        },
        /**
         * 获取匹配输入框内容的智能提示
         */
        getSmartArr(content) {
            this.smartHtmlList = [];
            this.smartTextList = [];
            if(!content) return;
            this.smartList.map((item, index, array) => {
                let smartHtml = '';
                let smartHtmlArr = item.split('');
                for (let i = 0; i < content.length; i++) {
                  if (item.indexOf(content[i]) == -1) return;
                  for (let j = 0; j < smartHtmlArr.length; j++) {  // 使用循环解决内容出现span class="primary"时替换出现问题
                    if (smartHtmlArr[j].indexOf('span class="primary"') == -1)
                      smartHtmlArr[j] = smartHtmlArr[j].replace(content[i], `<span class="primary">${content[i]}</span>`)
                  }
                }
                smartHtml = smartHtmlArr.join('');
                this.smartHtmlList.push(smartHtml);
                this.smartTextList.push(item);
            });
        },
        /**
         * 添加表情
         * */
        // 添加emoji
        addEmoji(emoji, key) {
            let html = '<img src="' + require('@/assets/icon/emoji/' + emoji.icon) + '" data-code="' + key + '" class="chat-emoji-icon">';
            this.insertHtmlAtCaret(html);
        },
        /**
         * html to innerText
         * */
        htmlToStr(html) {
            return html.replace(/<img([\s\S])*?(\/)?>/g, ($0) => {
                const array = $0.split(" ");
                let src = $0;
                array.forEach(item => {
                    if (item.indexOf("data-code") >= 0) {
                        src = '[' + item.replace("data-code", "").replace(/['"=]/g, "") + ']';
                    }
                });
                return src;
            });
        },
        /**
         * 把文档标签转成字符串
         * */
        labelToStr(html){
            let labels = [];
            let content = html.replace(/&lt;input name="at"([\s\S])*?(\/)?&gt;/g, ($0) => {
                const array = $0.split(" ");
                let attr = $0;
                array.forEach(item => {
                    if (item.indexOf("label") >= 0) {
                        attr = item.replace("label", "").replace(/['"=]/g, "");
                        labels.push(attr);
                    }
                });
                return '';
            })
            return {content, labels};
        },
        /**
         * 按enter发送
         * @param { Object } ev
         */
        send(ev) {
            if(ev && ev.which == 13) {
                ev.preventDefault();
            }
            if (this.sending) {return}
            this.sendMsg('text');
            //this.$refs['inputContent'].blur();  // 解决键盘收起时页面没有回弹，出现空白
        },
        sendContent(){
            let html = document.getElementById('wlb_inputArea').innerHTML.trim();
            this.inputText = this.htmlToStr(html);
            this.sendMsg('text');
        },
        /**
         * 发送消息
         * @param { String } type    发送消息的类型  text=>文本  image=>照片
         * @param { String } content 发送消息的内容
         * @param { Object } param   新增参数
         * @param { Number } index   消息的索引
         */
        sendMsg(type, content, param, index) {
            if(type == 'text' && !content) {
                if (!this.inputText.trim()) {
                    Toast({
                        message: '请输入您的问题',
                        position: 'bottom'
                    });
                    return;
                }
                if (this.inputText.length > maxLength) {
                    Toast('发送内容消息超长，请重新编辑');
                    return;
                }
            }
            if (this.sending) {
                return;
            }
            this.sending = true;
            if (this.businessType == 2) {
                this.locking = true;
            }
            let date = Date.now(),
                msgId = dataHandle.getUid();
            let data = {
                accessKey: this.accessKey,
                skillGroupId: this.businessId,
                clientId: this.clientId,
                clientType: this.clientType,
                type: type,
                date: date,
                sender: 'user',
                status: 'loading',
                msgId: msgId,
                source: 'H5'
            };
            if(param) {
                Object.assign(data,param);
            }
            if(dataHandle.getCookie('X-User-Mobile')&&dataHandle.getCookie('X-User-Mobile') != "undefined") {
                data.account = dataHandle.getCookie('X-User-Mobile');
            }
            if (content) {
                data.content = content;
            } else {
                data.content = this.inputText;
            }
            if (type == 'text') {
                data.content = this.transformLink(data.content);
            }
            // 文档问答时，存在复制回答功能，当把回答复制到输入框时，发送存在标签，则去除
            if (this.businessType == 2) {
                data.content =data.content.replace(/&lt;div&gt;|&lt;br&gt;|&lt;\/div&gt;/g, "");
                // 把文档标签html转换成@label，并获取labelList提交后台(已去重)
                // 如果提取到labelList为空，则使用上一次的labelList
                const contentObj = this.labelToStr(data.content);
                data.content = contentObj.content;
                data.labelList = contentObj.labels.length>0 ? Array.from(new Set(contentObj.labels)) : this.slsLabelList;
            }
            if (data.content == '') {
                Toast({
                    message: '请输入您的问题',
                    position: 'bottom'
                });
                setTimeout(() => {
                    this.sending = false;
                    this.locking = false;
                    if(type == 'text')
                        this.contentInput();
                }, 500);
                return;
            }
            const that = this;
            CHAT.socket.emit('message', data, (res)=>{
                that.$parent.sendMsgCallback2Status(res);
            });
            let dataH = JSON.parse(JSON.stringify(data));
            if (this.businessType == 2) {
                dataH.extend = {
                    docLabels: data.labelList
                }
                // 保存labelList以便下次使用
                this.slsLabelList = data.labelList;
            }
            this.$parent.pushList(dataH);
            this.inputText = '';
            this.enterkey = false;
            const dom = document.querySelector('#wlb_inputArea');
            if (dom) {
                dom.innerHTML = '';
            }
            this.$parent.scrollBottom();
            setTimeout(() => {
                this.sending = false;
                if(type == 'text')
                    this.contentInput();
            }, 500);
            this.hideEmoji();
            this.inputBlur();
            // 普通消息发送2秒超时，文档问答消息发送30超时
            if (this.businessType == 2) {
                this.$parent.sendMsgTimeout(msgId, 60);
            }else{
                this.$parent.sendMsgTimeout(msgId, 2);
            }
        },
        /**
         * 转换http链接
         * */
        transformLink(content){
            content = content.replace(/</g, '&lt;').replace(/\>/g, '&gt;');
            let reg = /(http:\/\/|https:\/\/)([-A-Za-z0-9+&@#/%?=~_|!:,.;\*\(\)]+[-A-Za-z0-9+&@#/%=~_|\*\(\)])/g
            content = content.replace(reg, '<a href="$1$2">$1$2</a>');
            return content;
        },
        /**
         * 解决键盘收起时页面没有回弹，出现空白
         */
        inputBlur() {
            // console.log('===blur===');
            this.$parent.getConversationH();
            // ios12及ios13键盘收起后会有半屏白屏，ios12修改body的scrollTop，ios13修改html的scrollTop
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        /**
         * 解决键盘弹起时input被挡
         *
         */
        focusInput(event) {
            this.$refs['inputContent'].focus();
            this.$parent.hideTool();
            this.$parent.getConversationH();
            this.$parent.focusInput();
            this.hideEmoji();
        },
        /**
         * 发送智能提示消息
         * @param { Number } index ==> 消息的索引
         */
        sendSmartText(index) {
            this.inputText = this.smartTextList[index];
            this.smartHtmlList = [];
            this.smartTextList = [];
            this.sendMsg('text');
        },
        /**
         * 显示工具栏
        */
        async showTool() {
            if (this.emojiFlag) {
                this.hideEmoji();
                return;
            }
            this.$parent.showTool();
            this.inputBlur();
        },
        /**
         * 打开emoji
         * */
        showEmoji(){
            this.smartHtmlList = [];
            this.smartTextList = [];
            this.emojiFlag = true;
            this.$parent.showEmoji();
        },
        hideEmoji(){
            this.smartHtmlList = [];
            this.smartTextList = [];
            this.emojiFlag = false;
            this.$parent.showEmoji();
        },
        /**
         * 文档问答解锁
         * */
        unlock(){
            this.locking = false;
            this.$nextTick(()=> {
                this.$refs['inputContent'].focus();
            });
        },
        /**
         * 录音及键盘切换
         *
         */
        voiceBtnClick(type) {
            this.hideEmoji();
            if (type == 'voice') {
                // 在ios的微信不使用recorder.js,使用微信api
                // if(!this.isIosWechat()) this.loadVoiceSetting(); ios设备已在外层拦截，则无法进行此操作
                // 获取录音权限
                this.loadVoiceSetting();
            }else{
                this.voiceBtnShow = !this.voiceBtnShow;
                this.$nextTick(()=>{
                    if (this.voiceBtnShow) {
                        this.$refs.inputContent.focus();
                    }
                });
            }
            this.inputBlur();
        },
        /**
         * 加载录音权限
         */
        loadVoiceSetting() {
            // console.log('===load===');
            this.record.recorder = Recorder({
                type: this.record.setting.type
                ,bitRate: this.record.setting.sampleBits
                ,sampleRate: this.record.setting.sampleRate
                ,onProcess:(buffers,level,time,sampleRate)=>{
                    this.record.duration = Math.round(time/1000);
                    this.record.rate = level;
                    this.record.countdown = this.record.maxTime - this.record.duration;
                    if(this.record.countdown<=0&&this.record.cancel) {
                        this.cancel();
                    }else if(this.record.countdown<=0&&!this.record.cancel) {
                        this.stop();
                    }
                }
            });
            this.record.recorder.open((()=>{
                this.voiceBtnShow = !this.voiceBtnShow;
            }),(()=>{
                // 拒绝授权
                this.isIos = true;
            }));
            window.waitDialogClick=()=>{
                console.log("打开失败：权限请求被忽略，用户主动点击的弹窗");
            };
        },
        /**
         * 微信（或企业微信）中打开
         * @returns
         */
        isWeChatOpen() {
            return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
        },
        /**
         * 企业微信中打开
         * @returns
         */
        isWeChatWorkOpen() {
            return navigator.userAgent.toLowerCase().indexOf('wxwork') > -1;
        },
        /**
         * 苹果设备中打开
         * @returns
         */
        isIosApp() {
            return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
        },
        /**
         * 在苹果设备的微信中访问
         * @returns
         */
        isIosWechat() {
            let isIosWexin = this.isWeChatOpen() && this.isIosApp();
            return isIosWexin;
        },
        /**
         * 获取微信签名
         */
        async getTicket() {
            let res = null;
            if(this.isWeChatWorkOpen()) {

            }else {
                res = await this.$http.wechatRequest(`/ticket/jsapi?accessKey=${this.accessKey}`);
            }
            if(!res) return;
            let data = res;
            let config = {
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature,// 必填，签名，见附录1
                jsApiList: ['startRecord','stopRecord','onVoiceRecordEnd', 'uploadVoice'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            }
            if(this.isWeChatWorkOpen()) {
                config.beta = true; // 企业微信必须这么写，否则wx.invoke调用形式的jsapi会有问题
            }
            wx.config(config);
            wx.ready(()=>{
                wx.startRecord({
                    success: (e)=>{
                        setTimeout(() => {
                            wx.stopRecord();  // 为了授权获取录音权限，获取后马上关闭
                        }, 400);
                    }
                })
            });
            wx.error((res)=>{
                console.log(res);
            })
        },
        /**
         * 开始录音
         */
        touchstart(event) {
            // 未打开录音
            if(!this.record.recorder && !this.isIosWechat() && !Recorder.IsOpen()) {
                return;
            }
            this.isClick = true;
            // console.log('===touchstart===');
            this.clickTimeout && clearTimeout(this.clickTimeout)
            this.clickTimeout = setTimeout(() => {
                this.isClick = false;
                this.touch.startX = event.changedTouches[0].pageX;
                this.touch.startY = event.changedTouches[0].pageY;
                if(this.isIosWechat()) {  // ios微信录音
                    // console.log('===wechat start===');
                    wx.ready(()=>{
                        setTimeout(() => {
                            this.record.press = true;
                            this.record.duration = 0;
                            wx.startRecord({
                                success: (e)=>{
                                    this.record.intervaltimerid = setInterval(() => {
                                        // 开始累积
                                        this.record.duration++;
                                        this.record.countdown = this.record.maxTime - this.record.duration;
                                        if(this.record.countdown<=0&&this.record.cancel) {
                                            this.cancel();
                                        }else if(this.record.countdown<=0&&!this.record.cancel) {
                                            this.stop();
                                        }
                                        // console.log('startRecord===',this.record.duration);
                                    }, 1000);
                                    this.record.intervaltimerRate = setInterval(()=>{
                                        //获取1-10之间的随机数
                                        this.record.rate = Math.floor(Math.random() * 100) + 1;
                                        // console.log('===rate===',this.record.rate);
                                    },200);
                                }
                            })
                        }, 300);
                    });
                    return;
                }else { // 非ios微信录音
                    this.record.recorder.open(()=>{
                        // console.log("已打开:"+this.record.setting.type+" "+this.record.setting.sampleRate+"hz "+this.record.setting.sampleBits+"kbps");
                        this.record.press = true;
                        this.record.duration = 0;
                        this.record.recorder.start();
                    },(e,isUserNotAllow)=>{
                        console.log((isUserNotAllow?"UserNotAllow，":"")+"打开失败："+e);
                    });
                }
            }, 500);
            if (event.cancelable) event.preventDefault(); //阻止默认事件（长按的时候出现复制）
        },
        /**
         * 移动事件
         *
         * ====================
         * Math.abs(X) > Math.abs(Y) && X > 0     left to right
         * Math.abs(X) > Math.abs(Y) && X < 0     right to left
         * Math.abs(Y) > Math.abs(X) && Y > 0     top to bottom
         * Math.abs(Y) > Math.abs(X) && Y < 0     bottom to top
         */
        touchmove(event) {
            // console.log('===move===',this.record.recorder);
            if (event.cancelable) event.preventDefault();//阻止滚动
            let moveEndX = event.changedTouches[0].pageX;
            let moveEndY = event.changedTouches[0].pageY;
            this.touch.moveDistanceX = moveEndX - this.touch.startX;
            this.touch.moveDistanceY = moveEndY - this.touch.startY;
            // console.log('countdown==>',this.record.countdown);
            if (Math.abs(this.touch.moveDistanceY) > Math.abs(this.touch.moveDistanceX) && this.touch.moveDistanceY < -10) {
                this.record.isSwipeTop = true;
                if(this.touch.moveDistanceY < -30) {  // 继续录音不暂停
                    this.record.cancel = true;
                }else {
                    this.record.cancel = false;
                }
            }
            // 兼容浏览器，由原来的-10改为-30
            if (this.touch.moveDistanceY >= -30) {
                this.record.isSwipeTop = false;
            }
        },
        /**
         * 结束录音
         * this.touch.moveDistanceY < -30    取消录音，销毁实例
         * else                              继续录音
         */
        touchend(event) {
            // console.log('===touch end===',this.record.recorder);
            clearTimeout(this.clickTimeout);
            this.clickTimeout = null;
            if(this.isClick) {
                this.cancel();
                return;
            }
            if(!this.isIosWechat() && !Recorder.IsOpen()) {
                this.cancel();
                return;
            }
            if(this.touch.moveDistanceY < -30 && this.record.cancel) {
                this.cancel();
            }else {
                if(this.record.duration >= 1) {  // 录音时长
                    this.stop();
                }else {
                    Toast({
                        message: '录音时间过短',
                        duration: 400
                    });
                    this.cancel();
                }
            }
        },
        /**
		 * 停止录音
		*/
		stop(){
            // console.log('===stop===');
            clearInterval(this.record.intervaltimerid);
            clearInterval(this.record.intervaltimerRate);
            if(this.isIosWechat()) {
                // console.log('===wechat stop===');
                wx.stopRecord({
                    success: (res)=>{
                        this.record.recordId = res.localId;
                        this.upload();
                    }
                });
            }else if(this.record.recorder){
                this.record.recorder.stop((blob,time)=>{
                    let audio = {blob:blob,time:time};
                    this.record.file = audio.blob;
                    this.upload();
                },(s)=>{
                    console.log("失败："+s);
                });
            }else{
                console.log("未打开录音");
            };
            this.record.press = false;
        },
        /***
         * 取消录音
         */
        cancel() {
            // console.log('cancel recorder');
            this.record.isSwipeTop = false;
            this.record.press = false;
            if(this.isIosWechat()) {
                wx.stopRecord();
                clearInterval(this.record.intervaltimerid);
                clearInterval(this.record.intervaltimerRate);
            }else {
                this.record.recorder.stop();
                // setTimeout(() => {
                //     if(Recorder.IsOpen()) {
                //         this.record.recorder.close(()=>{
                //             console.log('===关闭录音===');
                //         });
                //     }
                // }, 800);
            }
        },
        /**
         * 录音上传至微信获取文件流
         */
        upload() {
            if(this.isIosWechat()) {
                wx.uploadVoice({
                    localId: this.record.recordId,
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success: (res)=> {
                        this.record.file = res.serverId; // 返回音频的服务器端ID
                        this.uploadRecord();
                    }
                });
            }else {
                this.uploadRecord();
            }
        },
        /**
         * 上传音频文件流至后台，获取媒体文件id
         * @param { Number } type   1==>图片  3==>音频
         * @param { Number } channel   1==>H5
         * @returns
         */
        async uploadRecord() {
            // console.log('this blob==>,',this.record.file);
            let formData = new FormData();
            formData.append('accessKey', this.accessKey);
            formData.append('type', 3);
            formData.append('channel', 1);
            if(this.isIosWechat()) {
                console.log('...isIosWechat...');
                formData.append('url', `${window.api}/adaptor/wechat/media/${this.record.file}`);
            }else {
                formData.append('file', this.record.file);
            }
            let res = await this.$http.postFile(`/upload`,formData);
            // setTimeout(() => {
            //     if(Recorder.IsOpen()) {
            //         this.record.recorder.close(()=>{
            //             // console.log('===关闭录音===');
            //         });
            //     }
            // }, 800);
            if(!res || !res.data) {
                Toast(res.msg);
                return;
            }
            this.sendMsg('voice', res.data.fileId, {
                media: {
                    mediaId: res.data.fileId,
                    duration: this.record.duration
                }
            });
        },
        /**
         * 打开文档标签选择框
         * */
        showDocLabelWrap(e){
            if (this.docLabels.length > 1) {
                this.getPosition();
                setTimeout(()=>{
                    this.docLabelVisible = true;
                }, 120);
            }
        },
        /**
         * 关闭文档标签选择框
         * */
        closeDocLableWrap(){
            this.docLabelVisible = false;
        },
        /**
         * 选择标签
         * */
        selectLabel(label){
            this.atIndex++;
            const dom = document.querySelector('#wlb_inputArea');
            let fontW = 0.34+0.13;
            for (var i = 0; i < label.length; i++) {
                if (label.charCodeAt(i) > 255) {
                    fontW += 0.34;
                }else{
                    fontW += 0.17;
                }
            }
            let html = `<input name="at" value="@${label} " label="${label}" id="${this.atIndex}" class="custom-input-tag-doc" style="width: ${fontW.toFixed(2)}rem;" disabled="disabled" />`;
            this.insertHtmlAtCaret(html);
            this.$refs.inputContent.innerHTML = this.$refs.inputContent.innerHTML.replace(/@<input name="at"/, '<input name="at"');
            this.moveCaret();
            // setTimeout(()=>{
            //     let el = document.getElementById(this.atIndex);
            //     let range = document.createRange();
            //     let sel = this.getSelection();
            //     sel.removeAllRanges();
            //     // 将光标重新定位到自定义的a标签后面
            //     range.setStartAfter(el);
            //     range.setEndAfter(el);
            //     sel.addRange(range);
            // }, 10);

        },
        // 获取当前位置
        getPosition() {
            setTimeout(() => {
                // 获取当前光标位置getSelection()
                const selection = this.getSelection();
                if (selection.rangeCount === 0) {
                    return false
                }
                // 获取选中区域的范围 获取光标的范围
                const range = selection.getRangeAt(0);
                // 获取选中区域的边界 获取当前光标的坐标点 这个方法里面都有getBoundingClientRect()
                const { top, left } = range.getBoundingClientRect()
                // 获取当前光标的位置
                const cursorPosition = {
                    x: left,
                    y: top + range.getBoundingClientRect().height,
                }
                let clientWidth = document.getElementsByClassName('input-component')[0].clientWidth;
                if (cursorPosition.x + 170 >= clientWidth) {
                    this.LabelLeft = clientWidth - 170;
                }else{
                    this.LabelLeft = cursorPosition.x;
                }
                
            }, 80)
        },
        getSelection() {
            var selectedRange = null;
            if (window.getSelection) {
                selectedRange = window.getSelection();
            } else {
                selectedRange = document.getSelection();
            }
            return selectedRange;
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/webot/input-area/_input-area.js